(function () {
  function qs(root, selector) { return root ? root.querySelector(selector) : null; }

  function enableInput(input, enable) {
    if (!input) return;
    input.disabled = !enable;
  }

  function setHidden(form, key, value, enable) {
    var input = qs(form, '[data-ng-engraving-property="' + key + '"]');
    if (!input) return;
    input.value = value || '';
    input.disabled = !enable;
  }

  function makeKey() {
    return 'ng-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }

  function normaliseText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function getMode(module) {
    var active = qs(module, '[data-ng-engraving-type-input]:checked');
    return active ? active.value : 'text';
  }

  async function addEngravingService(module, form, key, mode, text, hasLogo) {
    if (!module || module.dataset.serviceEnabled !== 'true') return;

    var variantId = module.dataset.serviceVariantId;
    if (!variantId) return;

    var qtyInput = qs(form, '[name="quantity"]');
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    var serviceProperties = {
      'For': module.dataset.productTitle || 'Northgate watch',
      'Engraving type': mode === 'logo' ? 'Logo upload' : 'Text',
      '_ng_engraving_key': key || '',
      '_ng_engraving_service': 'true'
    };

    if (mode === 'text' && text) serviceProperties['Engraving text'] = text;
    if (mode === 'logo' && hasLogo) serviceProperties['Engraving logo'] = 'Logo uploaded';

    var body = {
      items: [{
        id: Number(variantId),
        quantity: quantity,
        properties: serviceProperties
      }]
    };

    try {
      await fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      });

      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true, cancelable: false }));
    } catch (error) {
      console.warn('Northgate engraving service could not be added.', error);
    }
  }

  function initModule(module) {
    if (!module || module.dataset.initialized === 'true') return;
    module.dataset.initialized = 'true';

    var form = module.closest('form');
    var productFormEl = form ? form.closest('product-form') : null;
    if (!form) return;

    var trigger = form.querySelector('[data-ng-engraving-trigger]');
    var modal = qs(module, '[data-ng-engraving-modal]');
    var textInput = qs(module, '[data-ng-engraving-text-input]');
    var logoInput = qs(module, '[data-ng-engraving-logo-input]');
    var logoPreview = qs(module, '[data-ng-engraving-logo-preview]');
    var textPreview = qs(module, '[data-ng-engraving-text-preview]');
    var count = qs(module, '[data-ng-engraving-count]');
    var save = qs(module, '[data-ng-engraving-save]');
    var status = qs(module, '[data-ng-engraving-status]');
    var statusText = qs(module, '[data-ng-engraving-status-text]');
    var edit = qs(module, '[data-ng-engraving-edit]');
    var clear = qs(module, '[data-ng-engraving-clear]');
    var typeInputs = Array.prototype.slice.call(module.querySelectorAll('[data-ng-engraving-type-input]'));
    var currentKey = '';
    var logoObjectUrl = '';

    function hasLogo() {
      return !!(logoInput && logoInput.files && logoInput.files.length);
    }

    function updateChoiceUi() {
      var mode = getMode(module);

      module.querySelectorAll('[data-ng-engraving-choice-option]').forEach(function (option) {
        var input = qs(option, '[data-ng-engraving-type-input]');
        option.classList.toggle('is-active', !!input && input.checked);
      });

      module.querySelectorAll('[data-ng-engraving-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-ng-engraving-panel') !== mode;
      });

      enableInput(logoInput, mode === 'logo' && modal && modal.classList.contains('is-open'));
      updatePreview();
      updateLogoPreview();
    }

    function updatePreview() {
      var mode = getMode(module);
      var text = normaliseText(textInput ? textInput.value : '');

      if (textPreview) {
        textPreview.hidden = mode !== 'text';
        textPreview.textContent = text || 'Your text';
      }

      if (count) count.textContent = text.length;
    }

    function updateLogoPreview() {
      if (!logoInput || !logoPreview) return;

      var mode = getMode(module);

      if (logoObjectUrl) {
        URL.revokeObjectURL(logoObjectUrl);
        logoObjectUrl = '';
      }

      if (mode === 'logo' && hasLogo()) {
        var file = logoInput.files[0];
        if (file && file.type !== 'application/pdf') {
          logoObjectUrl = URL.createObjectURL(file);
          logoPreview.src = logoObjectUrl;
          logoPreview.hidden = false;
        } else {
          logoPreview.removeAttribute('src');
          logoPreview.hidden = true;
        }
      } else {
        logoPreview.removeAttribute('src');
        logoPreview.hidden = true;
      }
    }

    function openModal() {
      if (!modal) return;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ng-engraving-lock');
      updateChoiceUi();
      setTimeout(function () {
        if (getMode(module) === 'text' && textInput) textInput.focus();
        if (getMode(module) === 'logo' && logoInput) logoInput.focus();
      }, 50);
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ng-engraving-lock');
      enableInput(logoInput, false);
    }

    function buildSummary() {
      var mode = getMode(module);
      var text = normaliseText(textInput ? textInput.value : '');
      if (mode === 'logo') return hasLogo() ? 'Logo uploaded' : '';
      return text ? 'Text: ' + text : '';
    }

    function applyEngraving() {
      var mode = getMode(module);
      var text = normaliseText(textInput ? textInput.value : '');
      var logo = hasLogo();
      var active = mode === 'logo' ? logo : !!text;
      var typeLabel = mode === 'logo' ? 'Logo upload' : 'Text';

      if (active && !currentKey) currentKey = makeKey();
      if (!active) currentKey = '';

      setHidden(form, 'type', active ? typeLabel : '', active);
      setHidden(form, 'text', mode === 'text' ? text : '', active && mode === 'text' && !!text);
      setHidden(form, 'logo-note', (mode === 'logo' && logo) ? 'Logo uploaded' : '', active && mode === 'logo' && logo);
      setHidden(form, 'price', active ? (module.dataset.promoEnabled === 'true' ? module.dataset.freeText : module.dataset.priceText) : '', active);
      setHidden(form, 'key', currentKey, active);
      setHidden(form, 'service-variant-id', (active && module.dataset.serviceEnabled === 'true') ? module.dataset.serviceVariantId : '', active && module.dataset.serviceEnabled === 'true');
      enableInput(logoInput, mode === 'logo' && (active || (modal && modal.classList.contains('is-open'))));

      if (status) status.hidden = !active;
      if (statusText && active) {
        statusText.textContent = module.dataset.promoEnabled === 'true'
          ? 'Engraving added — ' + buildSummary() + ' — ' + module.dataset.freeText
          : 'Engraving added — ' + buildSummary() + ' — ' + module.dataset.priceText;
      }
      if (trigger) trigger.classList.toggle('is-active', active);
      return active;
    }

    function clearEngraving() {
      if (textInput) textInput.value = '';
      if (logoInput) logoInput.value = '';
      typeInputs.forEach(function (input) { input.checked = input.value === 'text'; });
      updateChoiceUi();
      applyEngraving();
      enableInput(logoInput, false);
    }

    if (trigger) trigger.addEventListener('click', openModal);
    if (edit) edit.addEventListener('click', openModal);
    if (clear) clear.addEventListener('click', clearEngraving);

    typeInputs.forEach(function (input) {
      input.addEventListener('change', updateChoiceUi);
    });

    module.querySelectorAll('[data-ng-engraving-close]').forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    if (textInput) textInput.addEventListener('input', updatePreview);
    if (logoInput) logoInput.addEventListener('change', updateLogoPreview);

    if (save) {
      save.addEventListener('click', function () {
        applyEngraving();
        closeModal();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal();
    });

    form.addEventListener('submit', function () {
      applyEngraving();
    }, true);

    function handleCartAdded() {
      var keyInput = qs(form, '[data-ng-engraving-property="key"]');
      if (!keyInput || keyInput.disabled || !keyInput.value) return;
      addEngravingService(module, form, keyInput.value, getMode(module), normaliseText(textInput ? textInput.value : ''), hasLogo());
    }

    if (productFormEl) {
      productFormEl.addEventListener('on:cart:add', handleCartAdded);
      productFormEl.addEventListener('on:line-item:change', handleCartAdded);
    }

    updateChoiceUi();
    enableInput(logoInput, false);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-ng-engraving-module]').forEach(initModule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
